import React, {
  memo,
  useCallback,
  useState,
  useContext,
  useEffect,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { ConfirmationModal } from 'ui/components/Modal/ConfirmationModal';
import { populateTestEnvironment } from 'services/sandbox';
import { sideDrawerStatus } from '../FBODrawer';

const PopulateSandboxSampleData = React.forwardRef((_props, ref) => {
  const [populateModalVisible, setPopulateModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { drawerExpanded } = useContext(sideDrawerStatus);

  const populateDataClicked = useCallback(async () => {
    setIsLoading(true);

    try {
      await populateTestEnvironment();
      navigate(0);
    } catch {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setPopulateModalVisible(false);
  }, [history]);
  useEffect(() => {}, [drawerExpanded]);
  return (
    <>
      {drawerExpanded && (
        <Button
          ref={ref as React.RefObject<HTMLButtonElement>}
          onClick={() => setPopulateModalVisible(true)}
          className="populate"
          disableRipple
        >
          Populate Sample Data
        </Button>
      )}

      <ConfirmationModal
        open={populateModalVisible}
        title="Populate Sandbox With Sample Data"
        onConfirmClicked={populateDataClicked}
        onCancelClicked={() => setPopulateModalVisible(false)}
        body="You are about to copy your sample data to your sandbox environment. You will lose any saved data in your sandbox. Do you want to continue?"
        confirmLabel="Yes"
        isLoading={isLoading}
      />
    </>
  );
});

export default memo(PopulateSandboxSampleData);
